function initRDHCountdown() {

  const countdown = document.querySelector('[data-rdh-countdown]');

  if (!countdown) return;

  if (countdown.dataset.initialized === 'true') return;
  countdown.dataset.initialized = 'true';

  const endDate = new Date(countdown.dataset.date).getTime();

  if (isNaN(endDate)) {
    console.error('Invalid countdown date:', countdown.dataset.date);
    return;
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function updateCountdown() {

    const distance = endDate - Date.now();

    if (distance <= 0) {

      countdown.querySelector('[data-days]').textContent = '00';
      countdown.querySelector('[data-hours]').textContent = '00';
      countdown.querySelector('[data-minutes]').textContent = '00';
      countdown.querySelector('[data-seconds]').textContent = '00';

      return;
    }

    const days = Math.floor(distance / 86400000);
    const hours = Math.floor((distance % 86400000) / 3600000);
    const minutes = Math.floor((distance % 3600000) / 60000);
    const seconds = Math.floor((distance % 60000) / 1000);

    countdown.querySelector('[data-days]').textContent = pad(days);
    countdown.querySelector('[data-hours]').textContent = pad(hours);
    countdown.querySelector('[data-minutes]').textContent = pad(minutes);
    countdown.querySelector('[data-seconds]').textContent = pad(seconds);

  }

  updateCountdown();

  setInterval(updateCountdown, 1000);

}

document.addEventListener('DOMContentLoaded', initRDHCountdown);
document.addEventListener('shopify:section:load', initRDHCountdown);
document.addEventListener('shopify:section:select', initRDHCountdown);